//import logo from './logo.svg';
import './App.css';
import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import { Button } from '@material-ui/core';
import useModal from 'react-hooks-use-modal';
import { render } from 'react-dom';




function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary">
      {'Copyright © '}
      <Link color="inherit" href="https://google.com/">
        LongBlack Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  textStyles: {
    fontfamily: 'Playfiar Display'
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  alignment: {
    display: 'flex',
    flexDirection: 'row',
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
  footer: {
    padding: theme.spacing(3, 2),
    marginTop: 'auto',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
  },
}));

const modalStyle = {
  backgroundColor: '#fff',
  padding: '60px 100px',
  borderRadius: '10px',
  width: 500,
  height: 500,
  overflow: 'scroll'
};

function App() {
  const classes = useStyles();

  const [Modal, open, close] = useModal('root', {
    preventScroll: false
  });

  return (

    <div className={classes.root}>
      <CssBaseline />
      <Container component="main" className={classes.main} maxWidth="sm">
        <div className={classes.alignment}>
          <Typography variant="h2" component="h1" gutterBottom>
            LongBlack
        </Typography>
          <img style={{ height: 60, width: 60, marginLeft: 10, }} src="./1024.png" alt="hi" />
        </div>
        <Typography variant="h6" component="h2" gutterBottom>

          {'A review and ratings based social media application where you can'}
          {' rate, review and share your experience with any product or service.'}
        </Typography>
        <Typography variant="body1">Every experience counts, even the bad ones.</Typography>

        <div style={{ padding: '15px 0px' }}>
          <Button color="primary" onClick={open}>Privacy Policy</Button>
        </div>
        <div>
          <Modal>
            <div style={modalStyle}>
              <h1>Data Policy </h1>
              <p>Welcome to LongBlack (the ‘Service’). This policy describes the information we collect and process to support and provide the LongBlack Service. </p>
              <h2>I. What kinds of information do we collect? </h2>
              <p>To provide the LongBlack Service, we must collect and process certain information about you. The types of information we collect depends on how you use our Service.</p>
              <h3>Information We Collect </h3>
              <p><u>Information and content you provide</u></p>
              <p>We collect the content, communications and other information you provide when you use our Service, including when you sign up for an account, create or share content, and message or communicate with others. This can include information in or about the content you provide (like metadata), such as the location of a photo or the date a file was created.</p>
              <p><u>Connections</u></p>
              <p>We collect information about the people you are connected to and how you interact with them across our Service, such as people you communicate with the most or groups you are part of. </p>
              <p><u>Your usage</u></p>
              <p>We collect information about how you use our Service, such as the types of content you view or engage with; the features you use; the actions you take; the people or accounts you interact with; and the time, frequency and duration of your activities. </p>
              <p><u>Things others do and information they provide about you</u></p>
              <p>We also receive and analyze content, communications and information that other people provide when they use our Service.  </p>
              <h2>II. How do we use this information?</h2>
              <p>We use the information we have described below to provide and support the LongBlack Service described in the Terms and Conditions. Here's how: </p>
              <h3>Improve our Service </h3>
              <p>We use the information we have to improve our Service via developing and introducing new analytics-based features as well as further enhancing our current features. </p>
              <h3>Promoting a Safe and Secure Environment </h3>
              <p>We use the information we have to investigate suspicious activity or violations of our terms and conditions in order to promote a safe and secure environment for all users.</p>
              <h3>Communication</h3>
              <p>We use the information we have to send you marketing communications, communicate with you about our Service, and let you know about our policies and terms. We also use your information to respond to you when you contact us.</p>
              <h2>III. How is this information shared? </h2>
              <p>Your information is shared with others in the following ways:</p>
              <h3>Sharing on the LongBlack Service</h3>
              <p><u>People and accounts you share and communicate with</u></p>
              <p>When you share and communicate using our Service, you choose the audience for what you share. For example, when you post on LongBlack, you select the audience for the post, such as a group, all of your friends, the public, or a customized list of people.</p>
              <p><u>Content others share about you </u></p>
              <p>You should consider who you choose to share with, because people who can see your activity on our Service can choose to share it with others on and off our Service, including people and businesses outside the audience you shared with. For example, when you share a review to specific friends or accounts, they can download, screenshot, or reshare that content to others across or off our Service. Also, when you comment on someone else's post or react to their content, your comment or reaction is visible to anyone who can see the other person's content, and that person can change the audience later. </p>
              <h3>Sharing with Third-Party Partners</h3>
              <p><u>Measurement partners</u></p>
              <p>We share information about you with companies that aggregate it to provide analytics and measurement reports to our partners</p>
              <p><u>Vendors and service providers </u></p>
              <p>We provide information and content to vendors and service providers who support our business, such as by providing technical infrastructure services, analyzing how our Service is used, providing customer service, facilitating payments or conducting surveys.</p>
              <p><u>Researchers and academics</u></p>
              <p>We also provide information and content to research partners and academics to conduct research that advances scholarship and innovation that support our business or mission, and enhances discovery and innovation on topics of general social welfare, technological advancement, public interest, health and well-being</p>
              <p><u>Law enforcement or legal requests </u></p>
              <p>We share information with law enforcement or in response to legal requests in the circumstances outlined below.</p>
              <h2>IV. How can I manage or delete information about me? </h2>
              <p>We provide you with the ability to access, rectify, and delete your data. We store data until it is no longer necessary to provide our services and LongBlack Service, or until your account is deleted - whichever comes first. This is a case-by-case determination that depends on things like the nature of the data, why it is collected and processed, and relevant legal or operational retention needs. When you delete your account, we delete things you have posted, such as your photos and status updates, and you won't be able to recover that information later. Information that others have shared about you isn't part of your account and won't be deleted. If you don't want to delete your account but want to temporarily stop using the Service, you can deactivate your account instead. </p>
              <h2>V. How do we respond to legal requests or prevent harm? </h2>
              <p>We access, preserve and share your information with regulators, law enforcement or others:</p>
              <p>a. In response to a legal request (like a search warrant, court order or subpoena) if we have a good faith belief that the law requires us to do so.</p>
              <p>b. When we have a good-faith belief it is necessary to: detect, prevent and address fraud, unauthorized use of the Service, violations of our terms or policies, or other harmful or illegal activity; to protect ourselves (including our rights, property or Service), you or others, including as part of investigations or regulatory inquiries; or to prevent death or imminent bodily harm. </p>
              <h2>VI. How will we notify you of changes to this policy? </h2>
              <p>We reserve the right to update this policy. We will notify you before we make changes to this policy and give you the opportunity to review the revised policy before you choose to continue using our Service.</p>
              <h2>VII. How to contact LongBlack with questions</h2>
              <p>If you have questions about this policy, you can contact us as described below. You can contact us by mail at: longblackdev@gmail.com</p>
              <button onClick={close}>CLOSE</button>
            </div>
          </Modal>
        </div>
      </Container>
      <footer className={classes.footer}>
        <Container maxWidth="sm">
          <Typography variant="body1">Drop us an email at longblackdev@gmail.com for any feature requests or feedback. We really appreciate it!</Typography>
          <Copyright />
        </Container>
      </footer>
    </div>
  );
}
render(<App />, document.getElementById('root'));
export default App;
